import { useFlexIgnoreZonesOnboardingStore } from "../../Sites/SiteAboutPage/FlexIgnoreZonesOnboarding/flexIgnoreZonesOnboardingStore";

/** Resolves when `loadCameraContext` finished (success or error) for this camera. */
export async function waitForFlexCameraContextReady(
  cameraId: number,
  signal: AbortSignal,
  maxWaitMs = 120_000
): Promise<void> {
  const start = Date.now();
  while (Date.now() - start < maxWaitMs) {
    if (signal.aborted) {
      return;
    }
    const ctx =
      useFlexIgnoreZonesOnboardingStore.getState().cameraContexts[cameraId];
    if (ctx && !ctx.loading) {
      return;
    }
    await new Promise((r) => setTimeout(r, 50));
  }
}
